
export default {
	props: {
		rating: {
			type: Number,
			required: true,
		},
		reviewCount: {
			type: String,
			required: true,
		},
		storeName: {
			type: String,
			required: true,
		},
		storeLink: {
			type: String,
			required: false,
			default: "",
		},
		reviewText: {
			type: String,
			required: true,
		},
	},
	computed: {
		isHomePage() {
			return this.$store.getters["navigation/isHomePage"];
		},
		stars() {
			let rating = this.rating;
			const stars = [];
			while (rating > 0) {
				if (rating >= 1) {
					stars.push(1);
					rating -= 1;
				} else {
					stars.push(rating);
					rating = 0;
				}
			}

			return stars;
		},
	},
};
